import { useState } from 'react';

const faqs = [
  {
    q: 'Was ist ein OOPBuy Spreadsheet?',
    a: 'Ein OOPBuy Spreadsheet ist eine strukturierte und organisierte Produktliste, die von erfahrenen OOPBuy-Nutzern erstellt wird. Es sammelt die besten Produkte mit Qualitätsbewertungen, Preisvergleichen und Versandinformationen &ndash; speziell für den deutschen Markt optimiert.',
  },
  {
    q: 'Ist das OOPBuy Spreadsheet kostenlos?',
    a: 'Ja, viele OOPBuy Spreadsheets sind kostenlos und werden von der Community gepflegt. Premium-Versionen mit erweiterten Funktionen sind ebenfalls verfügbar, aber für Einsteiger reicht ein kostenloses Spreadsheet völlig aus.',
  },
  {
    q: 'Wie oft wird das Spreadsheet aktualisiert?',
    a: 'Die Update-Frequenz variiert. Community-Spreadsheets werden oft täglich oder wöchentlich aktualisiert. Achte auf das Datum der letzten Aktualisierung, um sicherzustellen, dass du die aktuellsten Produktdaten nutzt.',
  },
  {
    q: 'Funktioniert das Spreadsheet auch für Österreich und die Schweiz?',
    a: 'Absolut! Die meisten Spreadsheets sind für den gesamten DACH-Raum optimiert. Versand- und Zollinformationen decken Deutschland, Österreich und die Schweiz ab.',
  },
  {
    q: 'Ist OOPBuy sicher für deutsche Käufer?',
    a: 'Ja, mit den richtigen Vorsichtsmaßnahmen ist OOPBuy sehr sicher. Nutze verifizierte Verkäufer aus dem Spreadsheet, fordere QC-Bilder an und verwende Zahlungsmethoden mit Käuferschutz. Das Spreadsheet enthält spezielle Sicherheitshinweise.',
  },
  {
    q: 'Wie kann ich das OOPBuy Spreadsheet am besten nutzen?',
    a: 'Filtere nach deinen Wunschkategorien, lies die Bewertungen, checke QC-Bilder und vergleiche Versandkosten. Das Spreadsheet ist dein Startpunkt &ndash; mit ein paar Klicks findest du die besten Produkte für deinen Style.',
  },
];

export default function FAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  return (
    <section id="faq" className="relative py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-[800px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <p className="text-xs md:text-sm font-medium tracking-widest uppercase text-primary-600 mb-3">
            Häufige Fragen
          </p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950">
            OOPBuy Spreadsheet FAQ
          </h2>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="rounded-xl bg-background-100 border border-background-200/60 overflow-hidden"
            >
              <button
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                className="w-full flex items-center justify-between gap-4 px-5 md:px-6 py-4 md:py-5 text-left cursor-pointer"
              >
                <span className="text-sm md:text-base font-semibold text-foreground-800">
                  {faq.q}
                </span>
                <span className={`w-6 h-6 rounded-full border border-foreground-200 flex items-center justify-center flex-shrink-0 transition-all duration-200 ${openIdx === idx ? 'bg-primary-500 border-primary-500' : ''}`}>
                  <i className={`text-xs transition-transform duration-200 ${openIdx === idx ? 'ri-subtract-line text-white rotate-180' : 'ri-add-line text-foreground-500'}`}></i>
                </span>
              </button>
              {openIdx === idx && (
                <div className="px-5 md:px-6 pb-5 md:pb-6">
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    {faq.a}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}